import React from "react";
import ContentForPage from "../../../containers/ContentForPage";

const CohortTab = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
      }}
    >
      <ContentForPage pageName="product_performance_cohort" />
    </div>
  );
};

export default CohortTab; 